// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"806":"47903f91","1919":"47903f91","6872":"deeb9ed0","7856":"47903f91"}[chunkId] + ".chunk.css";
};